var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8186 33H44C45.1046 33 46 33.8954 46 35C46 36.1046 45.1046 37 44 37H23.8186C22.8781 42.1202 18.3921 46 13 46C6.92487 46 2 41.0751 2 35C2 28.9249 6.92487 24 13 24C18.3921 24 22.8781 27.8798 23.8186 33ZM24.1814 15H4C2.89543 15 2 14.1046 2 13C2 11.8954 2.89543 11 4 11H24.1814C25.1219 5.87976 29.6079 2 35 2C41.0751 2 46 6.92487 46 13C46 19.0751 41.0751 24 35 24C29.6079 24 25.1219 20.1202 24.1814 15ZM13 42C16.866 42 20 38.866 20 35C20 31.134 16.866 28 13 28C9.13401 28 6 31.134 6 35C6 38.866 9.13401 42 13 42ZM35 20C38.866 20 42 16.866 42 13C42 9.13401 38.866 6 35 6C31.134 6 28 9.13401 28 13C28 16.866 31.134 20 35 20Z",
    fill: "#39585C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIconDark);
export default __webpack_public_path__ + "static/media/adminIconDark.a29ad9baf864d25d6b71feb930bb8d5a.svg";
export { ForwardRef as ReactComponent };